import { useStyles } from './side-by-side-chart.style'

export const SideBySideChart = function ({ children, data, missingChartStyles = {}, ...props }) {
  const classes = useStyles()

  if (data) {
    return (
      <div data-qa="side-by-side-chart" {...props}>
        {children}
      </div>
    )
  } else {
    return (
      <div className={classes.missingChartMessage} style={missingChartStyles}>
        <p>
          The filter combination you selected does not have any data associated with it.
        </p>
        <p>
          Please select a different combination.
        </p>
      </div>
    )
  }
}
